import { NavLink } from "react-router-dom";

const tabs = [
  { to: "/", label: "首页", icon: "ri-home-5-line", end: true },
  { to: "/category", label: "分类", icon: "ri-apps-2-line", end: false },
  { to: "/search", label: "搜索", icon: "ri-search-2-line", end: false },
  { to: "/favorites", label: "我的", icon: "ri-heart-3-line", end: false },
];

export default function MobileTabBar() {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 border-t border-background-200 bg-background-100/95 backdrop-blur md:hidden">
      <div className="flex h-14 items-stretch">
        {tabs.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            className={({ isActive }) =>
              `flex flex-1 flex-col items-center justify-center gap-0.5 text-[11px] transition-colors ${
                isActive ? "text-primary-400" : "text-foreground-500"
              }`
            }
          >
            <i className={`${tab.icon} text-xl`}></i>
            {tab.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}